import { __require as requireSemver } from "../classes/semver.js";
var minor_1;
var hasRequiredMinor;
function requireMinor() {
  if (hasRequiredMinor) return minor_1;
  hasRequiredMinor = 1;
  const SemVer = requireSemver();
  const minor = (a, loose) => new SemVer(a, loose).minor;
  minor_1 = minor;
  return minor_1;
}
export {
  requireMinor as __require
};
//# sourceMappingURL=minor.js.map
